import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UpdateCurrentPayload {
  page?: string;
  title: string;
  parent?: any;
  referrer?: string | null;
}
export interface BreadcrumbState {
  current: {
    [key: string]: any;
    url: string;
    lastUpdatedKey: string;
  };
  previous: {
    [key: string]: any;
    url: string;
  };
  parent: {
    path: string;
    name: string;
  } | null;
  loading: boolean;
}

const initialState: BreadcrumbState = {
  current: {
    home: {
      title: "Home"
    },
    url: "/",
    lastUpdatedKey: ""
  },
  parent: null,
  previous: {
    url: "/"
  },
  loading: false
};

const BreadcrumbSlice = createSlice({
  name: "breadCrumb",
  initialState,
  reducers: {
    updateBreadcrumb(state, action: PayloadAction<UpdateCurrentPayload>) {
      const { page = "other", title, referrer, parent = null } = action.payload;

      return {
        ...state,
        current: {
          ...state.current,
          [page]: {
            title,
            parent,
            referrer
          },
          parent,
          lastUpdatedKey: page
        },
        previous: {
          ...state.previous,
          title: state.current[state.current.lastUpdatedKey]?.title
        },
        loading: false
      };
    },
    updateUrl(state, action: PayloadAction<string>) {
      const { payload } = action;
      if (state.current.url !== payload) {
        return {
          ...state,
          previous: {
            ...state.previous,
            url: state.current.url
          },
          current: {
            ...state.current,
            url: payload,
            parent: null
          },
          loading: true
        };
      }
      return state;
    }
  }
});

export const { updateBreadcrumb, updateUrl } = BreadcrumbSlice.actions;
export default BreadcrumbSlice;
